import {
  singleOrderStatusPriority,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_PARTIALLY_CANCELLED,
  ORDER_STATUS_CANCELLATION_IN_PROGRESS,
  ORDER_STATUS_AWAITING_CREDIT_CHECK,
} from './constants';

export class GroupOrderService {
  static transformResponse({ result: { Orders, PlacedOn } }: Response<dto.GroupOrderSummaryDTO>) {
    const [ordersNumbers, ordersStatuses] = Orders.reduce((acc, { OrderNumber, Status }) => ([
      [...acc[0], OrderNumber],
      [...acc[1], Status],
    ]), [[], []] as string[][]);

    return {
      ordersNumbers,
      orderStatusFromGOC: this.getOrderStatusFromGOC(ordersStatuses),
      placedOn: PlacedOn,
      isGOCFetched: true,
    };
  }

  static getOrderStatusFromGOC(ordersStatuses: string[]): string {
    const isStatusSame = ordersStatuses.every(ordersStatus => ordersStatus === ordersStatuses[0]);

    if (isStatusSame) {
      return ordersStatuses[0];
    }

    if (ordersStatuses.includes(ORDER_STATUS_AWAITING_CREDIT_CHECK)) {
      return ORDER_STATUS_AWAITING_CREDIT_CHECK;
    }

    const notCancelledStatuses = ordersStatuses
      .filter(status => status !== ORDER_STATUS_CANCELLATION_IN_PROGRESS && status !== ORDER_STATUS_CANCELLED);

    if (ordersStatuses.includes(ORDER_STATUS_CANCELLATION_IN_PROGRESS)
      && ordersStatuses.includes(ORDER_STATUS_CANCELLED)) {
      return notCancelledStatuses.length ? ORDER_STATUS_PARTIALLY_CANCELLED : ORDER_STATUS_CANCELLATION_IN_PROGRESS;
    }

    if (ordersStatuses.includes(ORDER_STATUS_CANCELLED)
    || ordersStatuses.includes(ORDER_STATUS_CANCELLATION_IN_PROGRESS)) {
      return ORDER_STATUS_PARTIALLY_CANCELLED;
    }

    const ordersIndexes = ordersStatuses.map(status => singleOrderStatusPriority.indexOf(status));
    const orderIndex = Math.min(...ordersIndexes);

    return singleOrderStatusPriority[orderIndex];
  }
}
